import VuexPersistence from "vuex-persist";

export function createPersistence(reducer) {
  return new VuexPersistence({
    reducer: (state) => reducer(state),
    storage: {
      getItem: (key) => window.localStorage.getItem(key),
      setItem: (key, value) => {
        return window.localStorage.setItem(key, value);
      },
      removeItem: () => window.localStorage.removeItem(key),
    },
  }).plugin;
}
export function clearStorage() {
  localStorage.clear();
}
